/* React */
import React from "react";

/* Ionic */
// import { expand } from "ionicons/icons";

/* Components */
// import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./ChartWrapperOptions.module.scss";

/* Interfaces */
interface ChartWrapperOptionsProps {
  options: React.ReactNode;
}

const ChartWrapperOptions: React.FC<
  ChartWrapperOptionsProps
> = ({ options }) => {
  return (
    <div className={styles.chart_wrapper_options}>
      {options}
      {/* <PrimaryFabButton
        className={"primary small"}
        ariaLabel={"Expand button"}
        icon={expand}
      /> */}
    </div>
  );
};

export default ChartWrapperOptions;
